<template>
  <v-dialog v-model="dialog" :width="options.width" :style="{ zIndex: options.zIndex }" @keydown.esc="cancel">
    <v-card>
      <v-card-title class="headline">{{title}}</v-card-title>
      <v-card-text v-show="!!message" class="pa-4">{{ message }}</v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <span v-if="options.type === 'confirm'">
          <v-btn class="text-none" dark color="#C4170C" @click.native="agree">Sim</v-btn>
          <v-btn class="text-none ml-1" light color="#0000004D" @click.native="cancel">Não</v-btn>
        </span>
        <span v-if="options.type === 'error' || options.type === 'success' ">
          <v-btn class="text-none" dark color="#C4170C" @click.native="agree">Entendi</v-btn>
        </span>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    name:"BaseConfirmDialog",
    data: () => ({
        dialog: false,
        resolve: null,
        reject: null,
        message: null,
        title: null,
        options: {
            color: 'primary',
            width: 350,
            zIndex: 200,
            type:'confirm'
        }
    }),
    methods: {
        open(title, message, options) {
            this.dialog = true
            this.title = title
            this.message = message
            this.options = Object.assign(this.options, options)
        },
        showError(title,message,options){
          this.options.type = 'error'
          this.open(title,message,options)
          return new Promise((resolve, reject) => {
            this.resolve = resolve
            this.reject = reject
          })
        },
        showSuccess(title,message,options){
          this.options.type = 'success'
          this.open(title,message,options)
          return new Promise((resolve, reject) => {
            this.resolve = resolve
            this.reject = reject
          })
        },
        showConfirm(title,message,options){
          this.options.type = 'confirm'
          this.open(title,message,options)
          return new Promise((resolve, reject) => {
            this.resolve = resolve
            this.reject = reject
          })
        },
        agree() {
            this.resolve(true)
            this.dialog = false
        },
        cancel() {
            this.resolve(false)
            this.dialog = false
        }
  }
}
</script>